<template>
    <div style="width: 100%; height: 400px; position: relative" v-loading="isLoading">
        <iframe
            :src="iframeSrc"
            width="100%"
            height="400"
            style="border: none"
        ></iframe>
        <div class="scan-mask-title">
            {{ $t('login.WeChatLogin') }}
        </div>
        <div class="scan-mask-bottom">
            <div>{{ $t('login.ScanToLogInSignTrustWithWechat') }}</div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { getLoginWechatIframeUrl } from '@/api/user'
import useLoading from '@/hooks/useLoading'

export default {
    name: 'ScanCodeForm',
    setup () {
        const { isLoading, showLoading, hideLoading } = useLoading()
        const iframeSrc = ref('')

        const initIframe = async () => {
            showLoading()
            iframeSrc.value = await getLoginWechatIframeUrl()
            hideLoading()
        }
        initIframe()

        return {
            iframeSrc,
            isLoading,
        }
    },
}
</script>

<style scoped lang="scss">
.scan {
    width: 100%;
    @include flex-box(flex-start, center, column);

    &-title {
        color: $color;
        font-size: 22px;
        font-family: $font-weight-5;
    }

    &-code {
        width: 208px;
        height: 208px;
        border-radius: 6px;
        border: 1px solid #cccccc;
        padding: 10px;
        margin-top: 32px;
    }

    &-open-wechat {
        margin-top: 23px;
        font-size: 16px;
        font-family: $font-weight-5;
        color: #333333;
    }

    &-agree {
        margin-top: 15px;
        font-size: 12px;
        font-family: $font-weight-5;
        color: #333333;
    }

    &-mask-title {
        position: absolute;
        width: 100%;
        top: 0;
        background-color: white;
        text-align: center;
        font-size: 20px;
    }

    &-mask-bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        height: 55px;
        background-color: white;
        text-align: center;
        color: rgb(55, 55, 55);
    }
}
</style>
